import { useParams } from "react-router-dom";
import { SampleProducts } from "../data/sampleProducts";
import Navbar from "../components/Header";
import Footer from "../components/Footer";
import ProductInfo from "../components/ProductInfo";

export default function ProductDetail() {
  const { id } = useParams();

  const product = SampleProducts.find((p) => p.id === Number(id));

  if (!product) return <p>Producto no encontrado.</p>;

  return (
    <main style={{ fontFamily: "Inter, Roboto, sans-serif", color: "#222", background: "#fff" }}>
      <Navbar />
      <ProductInfo product={product} />
      <Footer />
    </main>
  );
}
